
const COLOR_PRIMARY = '#39CA97'

/**
 * base64转换成blob，再将blob转换成file文件
 * @param dataurl 
 */
 const dataURLtoFile = (dataurl:string, fileName:string)=>{
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)![1]
  let u8arr = Buffer.from(arr[1], 'base64')
  console.log('mime', mime)
  return new File([new Blob([u8arr], {type:mime})], fileName, {type: mime, lastModified: Date.now()})
}

export {
  COLOR_PRIMARY,
  dataURLtoFile
}